/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * RESPONSIVE PRODUCT SPEC TABLE - added 17 Sept 2026.
 *
 * Problem: theme CSS pinned the label cells of the supplier spec table
 * (#product_description_table) to a fixed 40px, so long labels broke apart
 * letter by letter ("C O L L E C T I O N:") or overlapped their values.
 *
 * Fix: it stays a real table - same aligned columns, same row rules and
 * column rule the theme already draws. The label column simply sizes
 * itself to the longest label instead of a fixed width, and the value
 * column takes the rest. Words never break mid-word. On phones the labels
 * wrap at spaces rather than being forced onto one line.
 *
 * !important is required because the theme's own table rules are more
 * specific than a plain selector here.
 */
(function () {
  var css = [
    '#product_description_table{display:table!important;width:100%!important;max-width:100%!important;table-layout:auto!important}',
    '#product_description_table tbody{display:table-row-group!important}',
    '#product_description_table tr{display:table-row!important}',
    '#product_description_table th{display:table-cell!important;width:1%!important;min-width:0!important;max-width:none!important;white-space:nowrap!important;word-break:normal!important;overflow-wrap:normal!important;hyphens:none!important;text-align:left!important;vertical-align:top!important;padding:12px 24px 12px 0!important;position:static!important}',
    '#product_description_table td{display:table-cell!important;width:auto!important;min-width:0!important;vertical-align:top!important;padding:12px 0 12px 16px!important;word-break:normal!important;overflow-wrap:break-word!important;hyphens:none!important}',
    '@media (max-width:600px){#product_description_table th{white-space:normal!important;padding-right:14px!important}#product_description_table td{padding-left:12px!important}}',
    /* General safety net: no table in a product description breaks mid-word */
    '.Rte table{max-width:100%}',
    '.Rte th,.Rte td{word-break:normal;overflow-wrap:break-word;hyphens:none}',
    '.lobo-table-scroll{width:100%;max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}'
  ].join('');

  var style = document.createElement('style');
  style.setAttribute('data-lobo', 'responsive-tables');
  style.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(style);

  // Any OTHER table in a description that is still wider than its column
  // scrolls sideways instead of squashing its text.
  function wrapWideTables() {
    var tables = document.querySelectorAll('.Rte table');

    for (var i = 0; i < tables.length; i++) {
      var table = tables[i];

      if (table.id === 'product_description_table') {
        continue;
      }

      if (table.parentNode && table.parentNode.className === 'lobo-table-scroll') {
        continue;
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'lobo-table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapWideTables);
  } else {
    wrapWideTables();
  }
})();

/** Unique tabs using H6 as an anchor **/



document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});